import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import { SerializedData, SerializationContext, DataModelBuilder } from '../../../dto/data-model.js';
import { OpenAccessPass } from '../../open-access-pass/open-access-pass.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class OpenAccessPassRefundedForLegacyBackendEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'f205542757c640c092a11ef50e5d3376';

  private constructor(
    public readonly before: OpenAccessPass,
    public readonly after: OpenAccessPass,
  ) {
    super();
  }

  get $typeId(): string {
    return OpenAccessPassRefundedForLegacyBackendEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.EventOpenAccessPassRefunded;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      passId: this.after.uniqueId,
      orderId: this.after.orderId,
    };
  }

  static create(args: {
    before: OpenAccessPass,
    after: OpenAccessPass,
  }): OpenAccessPassRefundedForLegacyBackendEntry {
    return new OpenAccessPassRefundedForLegacyBackendEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): OpenAccessPassRefundedForLegacyBackendEntry {
    return this.create({
      before: context.fromData<OpenAccessPass>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<OpenAccessPass>(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return OpenAccessPassRefundedForLegacyBackendEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
           isSameData(other.after, this.after);
  }
}

export class OpenAccessPassRefundedForLegacyBackendEntryBuilder extends DataModelBuilder<OpenAccessPassRefundedForLegacyBackendEntry> {
  build(context: SerializationContext, map: SerializedData): OpenAccessPassRefundedForLegacyBackendEntry {
    return OpenAccessPassRefundedForLegacyBackendEntry.fromMap(context, map);
  }
}
